import React from 'react';
import { Chip } from '@mui/material';
import { useIntl } from 'react-intl';

type StatusChipProps = {
  value: boolean;
  trueLabelId: string;
  falseLabelId: string;
  invertColors?: boolean;
};

export const StatusChip = ({ value, trueLabelId, falseLabelId, invertColors = false }: StatusChipProps) => {
  const intl = useIntl();
  const isGood = invertColors ? !value : value;
  return (
    <Chip
      size="small"
      label={value ? intl.formatMessage({ id: trueLabelId }) : intl.formatMessage({ id: falseLabelId })}
      sx={{
        fontWeight: 700,
        fontSize: '0.7rem',
        height: 20,
        px: 0.25,
        backgroundColor: isGood ? '#40E4A115' : '#DF707015',
        color: isGood ? '#1cab72' : '#c55',
        border: `1px solid ${isGood ? '#40E4A145' : '#DF707045'}`,
      }}
    />
  );
};
